import React, { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import * as createHistory from "history";
import { useLoginOnStartup } from '@msx/platform-services';
import { configureStore } from '../../app/store';
import { appConfig } from '../../app/App.config';
import { initializeBot, initializeOcv } from '../utils'


const Window = window as any;
Window.hasStartupDataLoaded = false;

const history = createHistory.createBrowserHistory();
let { store } = configureStore()

initializeBot();
initializeOcv();

export const AppStoreProvider: React.FC<PropsWithChildren<{}>> = props => {

  useLoginOnStartup(appConfig.loginOnStartup);

  return (
    <Provider store={store}>
      {/* @ts-ignore */}
      <Router history={history}>
        {props.children}
      </Router>
    </Provider>
  );
}


// Generated by Copilot
// updated on: 2025-09-17 | 3 lines updated | [Manual] | Added explicit PropsWithChildren typing to ensure proper typing for children after upgrading from React 18.1 to 18.3.1 | Time Taken 2 min
// updated on: 2025-09-26 | 1 line updated | [Auto Generated] | Updated PropsWithChildren typing for React 18.3.1 compatibility | Time Taken 1 min
